<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="row">
        <div class="col-xs-12">
          <h5>
            My partners content
          </h5>
        </div>
      </div>
    </div>

    <LoadingSpinner v-if="loading"/>

    <ul v-else class="list-group">
      <li v-for="(contentNotification, index) in contentNotifications.data" class="list-group-item" style="padding: 10px 0">
        <div style="display: flex; flex-direction: row">
          <div class="text-muted" style="flex: 1; font-size: 24px; display: flex; justify-content: center; align-items: center; padding: 10px">
            <i v-if="contentNotification.attributes.content_type === 'content-articles'" class="fa fa-newspaper"/>
            <i v-if="contentNotification.attributes.content_type === 'content-events'" class="fa fa-calendar"/>
            <i v-if="contentNotification.attributes.content_type === 'content-files'" class="fa fa-file"/>
            <i v-if="contentNotification.attributes.content_type === 'content-jobs'" class="fas fa-user-md"/>
          </div>

          <div style="flex: 7 1 0%;">
            <a :href="contentNotification.attributes.content_url">
              {{ contentNotification.attributes.content_title }}
            </a>

            <br>

            <span>By: <router-link :to="'/companies/' + contentNotification.attributes.company_id">{{ contentNotification.attributes.portal_company_name }}</router-link></span>

            <span v-if="contentNotification.attributes.content_type === 'content-articles'" class="label label-info">Article</span>
            <span v-if="contentNotification.attributes.content_type === 'content-events'" class="label label-info">Event</span>
            <span v-if="contentNotification.attributes.content_type === 'content-files'" class="label label-info">File</span>
            <span v-if="contentNotification.attributes.content_type === 'content-jobs'" class="label label-info">Job</span>

            <br>

            <span>
              Portal: {{ contentNotification.attributes.portal_name }} | Publish date: {{ contentNotification.attributes.publish_at | date }}
            </span>
          </div>

          <div style="flex: 1; font-size: 24px; display: flex; justify-content: flex-end; align-items: center;">
            <button type="button" class="btn btn-lg" @click="dismiss(contentNotification, index)" style="background-color: transparent">
              <i class="fa fa-check-circle"></i>
            </button>

            <button type="button" class="btn btn-lg" @click="createReminder(contentNotification)" style="background-color: transparent">
              <i class="fa fa-calendar"></i>
            </button>
          </div>
        </div>
      </li>

      <li v-if="contentNotifications.meta.last_page > 1" class="list-group-item" style="padding: 10px 0">
        <pager :pagination="contentNotifications.meta" @navigate="page = $event"></pager>
      </li>

      <li v-if="contentNotifications.data.length === 0" class="list-group-item text-center" style="padding: 50px;">
        <i class="fa fa-bullhorn" style="font-size: 96px;"></i>

        <br><br>

        You have no content notifications!
      </li>
    </ul>

    <ContentNotificationReminderModal :content-notification="creatingReminder"/>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TaskListIcon from '@/pages/Dashboards/MyFocus/Panels/TaskList/TaskListIcon'
import ContentNotificationReminderModal from "./ContentNotificationReminderModal.vue";
import Pager from '@/components/Lists/Pager'

export default {
  components: {Pager, ContentNotificationReminderModal, LoadingSpinner, SelectWidget, TaskListIcon},

  data() {
    return {
      contentNotifications: null,

      creatingReminder: null,
      page: 1,
      loading: true,
    }
  },

  mounted() {
    this.load()
  },

  watch:{
    page(){
      this.load()
    }
  },

  methods: {
    load() {
      http.get('/api/v2/content-notifications', {page_size: 10, page: this.page}).then(response => {
        this.contentNotifications = response.data

        this.loading = false
      })
    },

    dismiss(contentNotification, index) {
      modal.confirm('Are you sure that you want to dismiss the content?', () => {
        http.post('/api/v2/content-notifications/' + contentNotification.id + '/dismiss')
            .then(() => {
              this.contentNotifications.data.splice(index, 1)

              notify.success('The content was dismissed')
            })
      })
    },

    createReminder(contentNotification) {
      this.creatingReminder = contentNotification

      $('#create-content-notification-reminder-modal').modal('show')
    },

    saveHeight() {
      if (this.$el.querySelector('.list-group')) {
        this.height = this.$el.querySelector('.list-group').clientHeight
      }
    }
  }
}
</script>
